import { useCallback } from 'react';

import { TServerSendRequest } from '../types';
import { useGenericSend } from './useGenericSend';

export const useSubmitPanicButtonDialog = () => {
    const send = useGenericSend();

    return useCallback(async (): Promise<{ message: string }> => {
        const { data } = await send<TServerSendRequest, { message?: string }>({
            ID: 89919,
            description: 'Panic Button Submit Dialog',
            responses: [89920]
        });

        return { message: data?.message || '' };
    }, [send]);
};
